import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import RsTable from '@Pages/RetroSynthesis/components/RsTable';
import PlanPublishedItem from '@Pages/RetroSynthesis/EditPlan/AddSteps/components/PlanPublishedItem';
import { Paginator } from '@els/els-react--paginator';
import GoToPage from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogFooter/GoToPage';
import PlanPublishedTableHeader from '@Pages/RetroSynthesis/EditPlan/AddSteps/components/PlanPublishedTableHeader';
import { getSelectionPropsForCheckbox } from '@Pages/RetroSynthesis/EditPlan/AddSteps/utils/selection';

import './PlanPredictedItems.scss';

function PlanPublishedItems({ databaseId, items, isInHouse, pagination, fetchData, selectedItems, setSelectedItems }) {
  const { totalElements, totalPages, size, number } = pagination || {};

  // Selection
  const customContainsFunc = (allItems, newItem) => allItems?.filter((item) => item.id === newItem.id).length > 0;

  const { isSelected, onSelectionChange } = getSelectionPropsForCheckbox({ selectedItems, setSelectedItems, customContainsFunc });
  return (
    <>
      <RsTable
        className={cn('rs-project-routes-table', 'plan-published-items', 'rx-reactions-table')}
        dataList={items}
        renderItem={(item) => (
          <PlanPublishedItem
            key={item.id}
            index={item}
            databaseId={databaseId}
            data={item}
            selected={isSelected(selectedItems, item)}
            onSelectionChange={onSelectionChange}
          />
        )}
        header={<PlanPublishedTableHeader isInHouse={isInHouse} />}
      />
      {totalPages > 1 && (
        <div className="plan-published__pagination u-els-padding-left u-els-margin-top-2x">
          <Paginator
            onPageChange={(page) => {
              fetchData({ size, page: page - 1 });
            }}
            resultsPerPage={size}
            totalResults={totalElements}
            currentPage={number + 1}
            shouldShowFirstLastButton
            maxPagesToShow={3}
            a11y={{ name: 'Published results', pagingUnitName: 'Page', morePagingUnit: 'More pages' }}
          />
          <GoToPage
            chunksCount={Math.ceil(totalElements / size)}
            onClick={(page) => {
              fetchData({ size, page: page - 1 });
            }}
          />
        </div>
      )}
    </>
  );
}

PlanPublishedItems.propTypes = {
  databaseId: PropTypes.string.isRequired,
  items: PropTypes.array,
  selectedItems: PropTypes.arrayOf(PropTypes.object),
  setSelectedItems: PropTypes.func,
  isInHouse: PropTypes.bool,
  pagination: PropTypes.object,
  fetchData: PropTypes.func,
};

export default PlanPublishedItems;
